import ConfirmationModal from '@/components/ConfirmationModal/ConfirmationModal';
import useGetUserTable from '@/services/table/queries/useGetUserTable';
import { replacePathParams } from '@/common/utils/utils';
import ROUTES from '@/routers/Routes';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ReducerState } from '@/services/common/lib/reducerState';
import useIsMobileView from '@/hooks/useIsMobileView';
import { delay } from 'lodash';
import { leaveTableAction } from '@/services/table/tableActions';

interface LeaveTableModalProps {
  isOpen: boolean;
  onClose: () => void;
  tableId: string;
}

const LeaveTableModal: FC<LeaveTableModalProps> = ({ isOpen, onClose, tableId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobileView = useIsMobileView();

  const user = useSelector((state: ReducerState) => state.auth);
  const tableState = useSelector((state: ReducerState) => state.tables?.[tableId]);

  const { data: userSeatsData } = useGetUserTable({
    userId: user.id!,
    selectedTableId: tableId,
    tableUrl: tableState?.url,
  });

  const redirectOnLeave = () => {
    let newTableId;
    if (userSeatsData?.data.seats.length! > 1) {
      newTableId =
        tableId !== userSeatsData?.data.seats[0].tableId
          ? userSeatsData?.data.seats[0].tableId
          : userSeatsData?.data.seats[1].tableId;
    }
    const newPath = newTableId
      ? replacePathParams(ROUTES.TABLE, {
          tableId: newTableId,
        })
      : ROUTES.LOBBY; //If we don't have other tableId to go, we redirect to lobby
    navigate(newPath);
  };

  const handleOnClickLeaveTable = async () => {
    try {
      dispatch(leaveTableAction(tableId));
      onClose();
      if (!isMobileView) {
        await delay(() => window.close(), 225);
      }
    } catch (error) {
      console.log(error);
    } finally {
      redirectOnLeave();
    }
  };

  return (
    <ConfirmationModal
      open={isOpen}
      onClose={onClose}
      onClickConfirm={handleOnClickLeaveTable}
      message="Are you sure you want to leave this table?"
      confirmText="Yes, leave table"
      cancelText="No, keep playing"
    />
  );
};

export default LeaveTableModal;
